import { Chip, Stack, Typography } from '@mui/material';
import UserAvatar from '../../../common/UserAvatar';
import { Box } from '@mui/material';
import { People } from '@mui/icons-material';
import { variants } from '../../../variants/variants';

const CustomRow = ({ delight }) => {
  return (
    <Stack direction={'row'} alignItems={'center'} sx={{ border: 0 }}>
      <UserAvatar src={delight[3]} />
      <Box sx={{ ml: 1 }}>
        <Typography sx={{ fontSize: variants.BODY, mb: 0.5 }}>{delight[1]}</Typography>
        {/* <Typography sx={{ fontSize: variants.BODY, }}>{delight[2]}</Typography> */}
        <Stack direction={'row'} alignItems={'center'} sx={{ mb: 0.5 }}>
          <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main, fontWeight: 600 }}>
            {delight[2]}
          </Typography>
          <Stack direction={'row'} alignItems={'center'} ml={1}>
            <People fontSize='small' sx={{ mr: 0.5 }} />
            <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main, fontWeight: 600 }}>
              {delight[4]}
            </Typography>
          </Stack>
        </Stack>
        <Typography sx={{ fontSize: variants.BODY }}>{delight[5]}</Typography>
      </Box>

      <Stack sx={{ ml: 'auto' }}>
        <Stack direction={'row'} justifyContent={'flex-end'}>
          <Typography sx={{ fontSize: variants.TINY, mr: 1 }}>HR:</Typography>
          <Chip
            size='small'
            sx={{
              mb: 1,
              backgroundColor:
                delight[6] === 'Pending'
                  ? 'rgba(255, 193, 7, 0.16)'
                  : delight[6] === 'Approved'
                  ? 'rgba(84, 214, 44, 0.16)'
                  : delight[6] === 'Rejected'
                  ? 'rgba(255, 72, 66, 0.16)'
                  : 'black',
              color:
                delight[6] === 'Pending'
                  ? '#B78103'
                  : delight[6] === 'Approved'
                  ? '#229A16'
                  : delight[6] === 'Rejected'
                  ? 'red'
                  : 'black',
              borderRadius: '6px',
              width: '5.5rem',
              fontWeight: 'bold',
            }}
            label={delight[6]}
          />
        </Stack>
        <Stack direction={'row'} justifyContent={'flex-end'}>
          <Typography sx={{ fontSize: variants.TINY, mr: 1 }}>Admin:</Typography>

          <Chip
            size='small'
            sx={{
              backgroundColor:
                delight[7] === 'Pending'
                  ? 'rgba(255, 193, 7, 0.16)'
                  : delight[7] === 'Approved'
                  ? 'rgba(84, 214, 44, 0.16)'
                  : delight[7] === 'Rejected'
                  ? 'rgba(255, 72, 66, 0.16)'
                  : 'black',
              color:
                delight[7] === 'Pending'
                  ? '#B78103'
                  : delight[7] === 'Approved'
                  ? '#229A16'
                  : delight[7] === 'Rejected'
                  ? 'red'
                  : 'black',
              borderRadius: '6px',
              width: '5.5rem',
              fontWeight: 'bold',
            }}
            label={delight[7]}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
export default CustomRow;
